export const VEHICLE_TYPE_OPTIONS = [
  { value: "sedan", label: "Sedan/Hatch" },
  { value: "wagon", label: "SUV/Wagon" },
  { value: "4wd", label: "4WD/7Seater" }
];

export const mapNevdisBodyTypeToVehicleType = (bodyType) => {
  if (!bodyType) {
    return "";
  }

  const normalized = String(bodyType).toUpperCase().replace(/[^A-Z0-9]/g, " ").trim();

  if (
    /\b(4WD|4X4|FOUR WHEEL|AWD|ALL WHEEL|UTILITY|UTE|DUAL CAB|CREW CAB|CAB CHASSIS|7 SEAT|SEVEN SEAT)\b/.test(
      normalized
    )
  ) {
    return "4wd";
  }

  if (/\b(SUV|WAGON|STATION|PEOPLE MOVER|MPV|VAN|MINIVAN)\b/.test(normalized)) {
    return "wagon";
  }

  if (/\b(SEDAN|HATCH|HATCHBACK|COUPE|CONVERTIBLE|ROADSTER|LIFTBACK)\b/.test(normalized)) {
    return "sedan";
  }

  return "";
};

export const getFieldsFromNevdisDetails = (vehicleDetails) => {
  if (!vehicleDetails) {
    return {};
  }

  const complianceYear = vehicleDetails.compliance_plate
    ? String(vehicleDetails.compliance_plate).split("-")[0]
    : "";
  const mappedVehicleType = mapNevdisBodyTypeToVehicleType(vehicleDetails.body_type);

  return {
    vin: vehicleDetails.vin || "",
    make: vehicleDetails.make || "",
    model: vehicleDetails.model || "",
    color: vehicleDetails.colour || "",
    modelYear:
      complianceYear ||
      (vehicleDetails.year_of_manufacture ? String(vehicleDetails.year_of_manufacture) : ""),
    vehicleType: mappedVehicleType,
    bodyType: vehicleDetails.body_type || ""
  };
};
